import * as CL from '@design-system/component-library';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useRouteLoaderData } from 'react-router';
import { CommonErrorType } from '../../common/enums.js';
import { deepEqual } from '../../common/utils/objectUtils.js';
import { getContactInfo } from '../../common/utils/stateUtils.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import { useSessionData } from '../../public/site/SessionDataProvider.js';
import { resetErrors } from '../../selfservice/actions/index.js';
import { EoeDeviceCheckoutThankYou } from '../EoeDeviceCheckoutThankYou/EoeDeviceCheckoutThankYou';
import { SystemError, hasSystemError } from '../SystemError/SystemError.js';
import { useCheckout } from './EoeCheckout.js';
import type { CheckoutRootLoaderData } from '../../common/loaders.js';
import type { State } from '../../selfservice/common/store.js';

export const EoeCheckoutThankYouOrError = () => {
  const { authenticatedUser } = useAuth();
  const { onlineOrderId, cartItems, deliveryDetails } = useSelector(
    (state: State) => ({
      onlineOrderId: state.deviceCheckout?.onlineOrderId,
      cartItems: state.deviceCheckout?.cartItems || [],
      deliveryDetails: state.deviceCheckout?.deliveryDetails,
    }),
    deepEqual
  );
  const companyInfo = useSessionData().companyInfo;
  const { models } = useRouteLoaderData('checkoutRootEmployee') as CheckoutRootLoaderData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { redirectPath } = useCheckout();
  const thankYouPageForbiddenError = [{ message: 'not allowed', type: CommonErrorType.FORBIDDEN }];

  if (onlineOrderId && authenticatedUser) {
    return (
      <EoeDeviceCheckoutThankYou
        cartItems={cartItems}
        companyInfo={companyInfo}
        contactInfo={getContactInfo(authenticatedUser)}
        deliveryDetails={deliveryDetails!}
        onlineModels={models}
      />
    );
  } else if (hasSystemError(thankYouPageForbiddenError)) {
    return (
      <SystemError
        errors={thankYouPageForbiddenError}
        onButtonClick={() => {
          dispatch(resetErrors());
          navigate(redirectPath);
        }}
      />
    );
  } else {
    return <CL.LoadingSpinner size="l" />;
  }
};
